import { cn } from "@eduviaos/ui-kit";

type PinState = "locked" | "available" | "completed";

const PIN_COLORS: Record<PinState, { fill: string; ring: string }> = {
  locked: { fill: "#94a3b8", ring: "#cbd5e1" },
  available: { fill: "hsl(var(--primary))", ring: "hsl(var(--primary) / 0.35)" },
  completed: { fill: "hsl(var(--joy-green))", ring: "hsl(var(--joy-green) / 0.35)" },
};

/** Numbered map-pin marker for the perspective road. */
export function RoadCheckpointPin({
  number,
  state,
  className,
}: {
  number: number;
  state: PinState;
  className?: string;
}) {
  const colors = PIN_COLORS[state];

  return (
    <div className={cn("relative grid place-items-center", className)}>
      <span
        className="absolute bottom-0 size-8 rounded-full blur-sm"
        style={{ background: colors.ring }}
        aria-hidden
      />
      <svg viewBox="0 0 48 64" width="100%" height="100%" aria-hidden>
        <path
          d="M24 4 C14 4 8 14 8 24 C8 38 24 58 24 58 C24 58 40 38 40 24 C40 14 34 4 24 4Z"
          fill={colors.fill}
        />
        <circle cx="24" cy="24" r="11" fill="#fff" fillOpacity="0.95" />
        {state === "completed" ? (
          <path
            d="M18 24 L22 28 L30 20"
            stroke={colors.fill}
            strokeWidth="2.5"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        ) : state === "locked" ? (
          <>
            <rect x="19" y="22" width="10" height="8" rx="1.5" fill="#64748b" />
            <path
              d="M21 22 V20 C21 17.8 22.8 16 25 16 C27.2 16 29 17.8 29 20 V22"
              stroke="#64748b"
              strokeWidth="2"
              fill="none"
            />
          </>
        ) : (
          <text x="24" y="28" textAnchor="middle" fontSize="11" fontWeight="800" fill={colors.fill}>
            {number}
          </text>
        )}
      </svg>
    </div>
  );
}
